import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/creators/{creatorId}/workflows/attachments';
type THIS_API = ApiDefinition['/creators/{creatorId}/workflows/attachments']['PUT'];
type Input = THIS_API['params'] & THIS_API['query'] & THIS_API['body'];
type Output = THIS_API['response'];

const getCreatorWorkflowAttachments = async ({
  attachmentTypeFilters,
  blocked,
  complete,
  creatorId,
  endDate,
  inProgress,
  page,
  perPage,
  search,
  startDate,
  sortDirection,
  sortField,
}: Input): Promise<Output> => {
  const body = {
    attachmentTypeFilters,
    blocked,
    complete,
    endDate,
    inProgress,
    search,
    sortDirection,
    sortField,
    startDate,
  };
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorId });
  const data = await noodleApiClient.put(path,
    body,
    {
      params: {
        page,
        perPage,
      },
    },
  );
  return data.data;
};

export default getCreatorWorkflowAttachments;
